// extracted by mini-css-extract-plugin
export default {"title":"Section_title__SLk8+","decor":"Section_decor__5ifY-","line":"Section_line__yCqOn"};